export default __webpack_public_path__ + "static/media/engine-gear-with-money.0bfcac0b.svg";